import { API_ERROR_MESSAGES } from 'constants/api-messages'
import { REGEX } from 'constants/common'
import { ERROR_MESSAGES } from 'constants/messages'
import { getDepartmentList } from 'services/department.service'
import { getManagerList } from 'services/manager.service'
import * as yup from 'yup'

let timerName: NodeJS.Timeout
let timerEmail: NodeJS.Timeout

export const VALIDATIONS = {
  MAX_LENGTH_TEXT: 256,
  MAX_LENGTH_CLIENT_NAME_TEXT: 50
}

export const createStaffSchema = yup.object().shape({
  name: yup
    .string()
    .required(ERROR_MESSAGES.F_TEXT_REQUIRED)
    .max(256, ERROR_MESSAGES.F_TEXT_MAXLENGTH_256)
    .matches(REGEX.EXCLUDE_SPECIAL_CHAR, ERROR_MESSAGES.F_TEXT_NO_SPEC_CHAR),
  department: yup.string().required(ERROR_MESSAGES.F_SELECT_REQUIRED)
})

export const createManagerAdminSchema = yup.object().shape({
  name: yup
    .string()
    .required(ERROR_MESSAGES.F_TEXT_REQUIRED)
    .max(256, ERROR_MESSAGES.F_TEXT_MAXLENGTH_256)
    .matches(REGEX.EXCLUDE_SPECIAL_CHAR, ERROR_MESSAGES.F_TEXT_NO_SPEC_CHAR),
  email: yup
    .string()
    .required(ERROR_MESSAGES.F_TEXT_REQUIRED)
    .matches(REGEX.EMAIL, ERROR_MESSAGES.F_TEXT_EMAIL_FORMAT)
    .max(256, ERROR_MESSAGES.F_TEXT_MAXLENGTH_256)
    .when(['clientId', 'managerEmail'], (client, schema) =>
      schema.test({
        test: (value) => {
          return new Promise((resolve) => {
            if (client[1] && client[1].toLowerCase() === value.trim().toLowerCase()) {
              return resolve(true)
            }
            clearTimeout(timerEmail)
            timerEmail = setTimeout(async () => {
              const response = await getManagerList({ email: value.trim().toLowerCase() })
              const items = response.items || []
              const emailExists: boolean = items.length !== 0
              resolve(!emailExists)
            }, 1000)
          })
        },
        message: API_ERROR_MESSAGES.EMAIL_ALREADY_TAKEN
      })
    ),
  role: yup.string().required(ERROR_MESSAGES.F_SELECT_REQUIRED)
})

export const createDepartmentSchema = yup.object().shape({
  name: yup
    .string()
    .required(ERROR_MESSAGES.F_TEXT_REQUIRED)
    .max(256, ERROR_MESSAGES.F_TEXT_MAXLENGTH_256)
    .matches(REGEX.EXCLUDE_SPECIAL_CHAR, ERROR_MESSAGES.F_TEXT_NO_SPEC_CHAR)
    .when(['clientId', 'departmentName'], (client, schema) =>
      schema.test({
        test: (value) => {
          return new Promise((resolve) => {
            if (client[1] && client[1].toLowerCase() === value.trim().toLowerCase()) {
              return resolve(true)
            }
            clearTimeout(timerName)
            timerName = setTimeout(async () => {
              const response = await getDepartmentList({ clientId: client[0] })
              const items = response.items || []
              const nameExists: boolean = items.some(
                (item: any) => item.name.toLowerCase() === value.trim().toLowerCase()
              )
              resolve(!nameExists)
            }, 1000)
          })
        },
        message: ERROR_MESSAGES.F_TEXT_UNREGISTER_DEPT_NAME
      })
    ),
  adminId: yup.number()
})
